<template>
	<div id="app"><router-view /></div>
</template>

<script>
export default {
	data() {
		return {};
	},
	methods: {}
};
</script>

<style lang="scss">
@import './assets/sass/flex.scss';
html,
body,
#app {
	height: 100%;
	margin: 0;
}
figure{
	display: block;
    margin: 0 auto;
	max-width: 100%;
	width: 100% !important;
	img{
		margin-left: auto;
		margin-right: auto;
		display: block;
	}
	figcaption {
		text-align: center;
		font-size: 12px;
		color: #999;
	}
}
body {
	font-size: 0.26rem;
}
div {
	box-sizing: border-box;
}
img {
	max-width: 100% !important;
}
.rich-text{
	p{
		text-indent: 2em;
	}
}
</style>
